import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { SEPARATOR_CONVERTER_TOKEN, SeparatorConverter } from './separator.component.converter'
import { FsComponentConverter } from 'fs-spartacus-common'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        separatorFeature: {
          module: () => import('./separator.module').then((m) => m.SeparatorModule),
          cmsComponents: ['separator']
        },
      }
    }),
    {
      provide: SEPARATOR_CONVERTER_TOKEN,
      useExisting: SeparatorConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        separator: SEPARATOR_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class SeparatorFeatureModule {}
